import { useTranslation } from "react-i18next"

import { getUserColor } from "shared/lib/user/getUserColor"
import { DateTime } from "shared/ui/date-time/DateTime"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Readonly } from "shared/ui/readonly/Readonly"
import { TextAvatar } from "shared/ui/text-avatar/TextAvatar"

import { isTeamRole } from "entities/team-members/types/TeamRole"

import { useClarificationRequestFormContext } from "./ClarificationRequestFormContext"

export function ClarificationRequestFormUpdatedAt() {
  const { t } = useTranslation()
  const { clarificationRequest, isLoading, lastUpdatedByMember } =
    useClarificationRequestFormContext()

  const lastUpdatedBy = clarificationRequest?.lastUpdatedBy

  if (!lastUpdatedBy && !clarificationRequest?.updatedAt) {
    return null
  }

  return (
    <Readonly.Root isLoading={isLoading}>
      <Readonly.Label>
        {t("ClarificationRequest.Form.UpdatedAt.Label")}
      </Readonly.Label>
      <Readonly.Value disableLocked className="d-flex flex-column gap-2 mt-1">
        {lastUpdatedBy ? (
          <div className="clarification-request-form__updated-by">
            <TextAvatar
              initials={lastUpdatedBy?.name?.at(0) ?? ""}
              className="text-avatar--small"
              color={getUserColor(lastUpdatedBy.id)}
            />
            <span className="clarification-request-form__updated-by-name">
              {lastUpdatedBy?.name}
            </span>
            {lastUpdatedByMember && isTeamRole(lastUpdatedByMember.role) ? (
              <span className="clarification-request-form__updated-by-role">
                {t(`Team.Role.${lastUpdatedByMember.role}`)}
              </span>
            ) : null}
          </div>
        ) : null}
        {clarificationRequest?.updatedAt && (
          <DateTime
            className="clarification-request-form__updated-at"
            isoTimestamp={clarificationRequest.updatedAt}
          >
            <div className="clarification-request-form__updated-at-icon">
              <Icon name={IconName.CALENDAR_CLOCK} />
            </div>
            <DateTime.Date />
            <DateTime.Time />
          </DateTime>
        )}
      </Readonly.Value>
    </Readonly.Root>
  )
}
